export default __webpack_public_path__ + "static/media/FRASES_12.d1f7e4b2.png";